// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import send03Icon from "@/assets/icons/send-03.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Send03IconProps = Omit<IconProps, "name">;

export function Send03Icon(props: Send03IconProps): React.ReactNode {
  return <Icon name={send03Icon} {...props} />;
}
